import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/solid";


function FaqPma() {
  return (
    <section class=" mt-4 flex flex-row flex-wrap justify-center items-center bg-slate-100">
      <div className="py-14 sm:py-20 ">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto text-center">
            <h2 className="text-2xl font-bold tracking-tight leading-10 text-gray-900 sm:text-2xl">
              <span className="font-bold text-indigo-800">Pacte civile de solidarité (Pacs) chez le notaire</span>
              : 5 informations importantes</h2>

          </div>
          <div className="mt-10 lg:col-span-7 lg:mt-0 sm:max-w-[60%] mx-auto">
            <dl className="space-y-10">

              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                Pourquoi faire un PACS chez un notaire ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                Passer par un notaire permet d’obtenir des conseils juridiques adaptés à votre situation personnelle. Le notaire sécurise la convention, s’assure qu’elle respecte la loi et peut vous aider à anticiper les conséquences en cas de séparation, de décès ou d’acquisition de biens communs. <br/>C’est la solution idéale si vous voulez protéger au mieux chacun des partenaires.
                 
                </dd>
              </div>

              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                Quels documents faut-il fournir pour un PACS chez le notaire ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                Chaque partenaire doit présenter :
                  <br />
                  <ul>
                    <li>• <span className="font-bold"> une pièce d’identité valide</span></li>
                    <li>• <span className="font-bold">un acte de naissance récent (moins de trois mois pour les actes français)</span> </li>
                    <li>• <span className="font-bold"> une attestation sur l’honneur indiquant que vous n’êtes ni marié(e), ni pacsé(e), ni lié(e) par un lien familial interdit</span></li>
                  </ul>
                </dd>
              </div>

              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                Le notaire s’occupe-t-il de l’enregistrement du PACS ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                Oui, après la signature de la convention de PACS, le notaire se charge de l’enregistrement auprès du service d’état civil compétent. Vous n’avez aucune démarche supplémentaire à effectuer. Une fois enregistré, vous recevrez une copie officielle (appelée « copie exécutoire ») qui prouve l’existence de votre PACS.
                </dd>
              </div>


              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                  Quelles sont les clauses que l'on peut ajouter à une convention de PACS ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                Dans une convention de PACS, vous pouvez intégrer plusieurs clauses spécifiques pour organiser vos relations financières et patrimoniales. Voici ce que vous pouvez prévoir concrètement :
                 <br />
                  <ul>
                    <li>• <span className="text-indigo-800 font-bold">Choix du régime patrimonial : séparation ou indivision</span> </li>
                    <li>• <span className="text-indigo-800 font-bold">Clause de participation aux charges</span> : Vous pouvez définir comment vous partagez les dépenses communes (loyer, nourriture, frais pour les enfants, crédits, etc.)</li>
                    <li>• <span className="text-indigo-800 font-bold">Précisions sur la propriété de certains biens</span> :  Vous pouvez lister des biens comme étant personnels, même s’ils sont achetés ensemble (ex : voiture, meubles)</li>
                    <li>• <span className="text-indigo-800 font-bold">Clauses de gestion des biens en cas de rupture</span> :  Organisation de la répartition des biens</li>
                    <li>• <span className="text-indigo-800 font-bold">Clauses en cas de décès</span> :  La possibilité de léguer certains biens par testament.</li>
                    <li>• <span className="text-indigo-800 font-bold">Autres clauses personnalisées</span> :  Protection du logement familial, Répartition des remboursements d’un crédit immobilier, Organisation spécifique pour une entreprise détenue par l’un des partenaires</li>
                    
                  </ul>
                </dd>
              </div>

              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                Combien coûte un PACS chez le notaire ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                  Pour un pacs chez le notaire il faut compter minimum 290€. Ce prix comprend la rémunération du notaire, les frais d'enregistrement de votre convention de PACS, les frais de formalités et la TVA. 
                </dd>
              </div>
            </dl>
          </div>


        </div>
        <div className="mx-auto text-center container">
          <p className="text-lg"> Débutez aujourd'hui votre dossier chez le notaire</p>
          <Link to="/onboard/pacs"
            type="button"
            className="btn-indigo p-6  no-underline inline-flex items-center w-auto"
          >
            Débuter mon dossier
            <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
          </Link>
        </div>

      </div>

    </section>
  );
}

export default FaqPma;